const d = (e) => ({ variants: {
  default: {
    size: e * 1.125,
    borderRadius: e * 0.25,
    font: "body3",
    boldOnChecked: !1,
    border: "BLACK",
    background: "WHITE"
  },
  boxed: {
    size: e * 1.125,
    borderRadius: e * 0,
    font: "ab3",
    boldOnChecked: !0,
    border: "BLACK_T_38"
  }
} });
export {
  d as default
};
//# sourceMappingURL=checkbox.js.map
